<template>
  <div>
    <van-nav-bar
      :title="$t('app.bind_phone.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="setPhone">
      <van-field
        v-model="user.phone"
        name="phone"
        :label="$t('app.bind_phone.current_mobile')"
        :placeholder="$t('app.bind_phone.current_mobile')"
        readonly
      />
      <van-field
        v-model="newPhone"
        name="newPhone"
        :label="$t('app.bind_phone.new_mobile')"
        :placeholder="$t('app.bind_phone.new_mobile')"
        :rules="[{ required: true, message: this.$t('app.bind_phone.new_mobile_dsc') }]"
      />
      <van-field
        v-model="sms"
        center
        clearable
        :label="$t('app.bind_phone.sms_verification')"
        :placeholder="$t('app.bind_phone.sms_verification_placeholder')"
        :rules="[{ required: true, message: this.$t('app.bind_phone.sms_verification_dsc') }]"
      >
        <template #button>
          <van-button
            native-type="button"
            size="small"
            plain
            type="info"
            @click="getCode"
            :disabled="disabled"
            >{{ getCodeText }}</van-button
          >
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button round block size="small" type="danger" native-type="submit">
          {{$t("app.common.sure")}}
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "BinkPhone",
  data() {
    return {
      sms: "",
      newPhone: "",
      getCodeText: this.$t('app.bind_phone.get_code'),
      disabled: false,
    };
  },
  computed: {
    phone: function () {
      return this.$store.state.phone;
    },
    user: function () {
      return this.$store.state.user;
    },
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    setPhone() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.newPhone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else if (that.sms == "") {
        that.$toast.fail(this.$t('app.common.enter_sms_code'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.newPhone.toString();
        let inputPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_phone_e",
              token: sessionStorage.getItem("token"),
              phone: inputPhone,
              code: that.sms,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: that.$t(res.data.msg),
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
      }
    },
    //获取验证码
    getCode() {
      let that = this;
      clearInterval(window.timer1);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.newPhone)) {
        that.$toast.fail(this.$t('app.common.phone_wrong_format'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.newPhone.toString();
        let inputPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modifyInfo_code_e",
              info: inputPhone,
              type: 2,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: that.$t(res.data.msg),
              });
              var time = 60;
              that.disabled = true;
              that.getCodeText = time + "s";
              window.timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  clearInterval(window.timer1);
                  that.disabled = false;
                  that.getCodeText = "获取验证码";
                }
              }, 1000);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BinkPhone.vue